import React, { useEffect, useState } from "react";
import CheckBoxIcon from "../../assets/icons/CheckBoxIcon";

export interface CustomCheckboxProps {
  onClickCheck: (state: boolean) => void;
  message: React.ReactNode;
  errorMessage: string;
  checked: boolean;
}
const CustomCheckbox: React.FC<Partial<CustomCheckboxProps>> = ({
  errorMessage,
  checked,
  onClickCheck,
  message,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);

  const handleClickCheck = () => {
    setIsChecked((prev) => {
      const newIsChecked = !prev;
      onClickCheck && onClickCheck(newIsChecked);
      return newIsChecked;
    });
  };

  useEffect(() => {
    setIsChecked((prev) => (prev = !!checked));
  }, [checked]);
  return (
    <>
      <div
        onClick={handleClickCheck}
        className="d-flex align-items-center gap-2 w-100"
        role="button"
      >
        <CheckBoxIcon aria-checked={isChecked} width={30} height={30} />{" "}
        {message && <>{message}</>}
      </div>
      {errorMessage && (
        <small className="text-danger text-nowrap">{errorMessage}</small>
      )}
    </>
  );
};

export default CustomCheckbox;
